import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';

export const demoFunc = () => demoPage('Reasoning', 'A quiet disclosure for the thinking behind a response.', html`
  <div class="reasoningDemo dees-demo-stack">
    <dees-harness-reasoning
      .reasoningParts=${[
        {
          id: 'r1',
          text: 'Summarize the failing test before touching code.\nThe user wants a summary of the failing test. I should read the test output first, then check the assertion that failed and compare with the fixture data.',
          startedAt: Date.now() - 9200,
          endedAt: Date.now() - 5200,
        },
        {
          id: 'r2',
          text: 'The fixture predates the schema change; regenerating it should settle both assertions.',
          startedAt: Date.now() - 5200,
          endedAt: Date.now() - 4100,
        },
      ]}
    ></dees-harness-reasoning>
    <dees-harness-reasoning
      .reasoningParts=${[
        {
          id: 'r3',
          text: 'Considering the tradeoffs between the two migration paths',
          startedAt: Date.now() - 1500,
        },
      ]}
    ></dees-harness-reasoning>
  </div>
`);
